import './IconNavclose.css';
import React from 'react';
import { styled } from 'linaria/lib/react';
const IconNavclose = _ref => {
  let {
    width = 15.679,
    height = 15.67920,
    className
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledSVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 15.679 15.679",
    className: className
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.461,3.22,18.9,4.658l-6.4,6.4,6.4,6.4L17.461,18.9l-6.4-6.4-6.4,6.4L3.22,17.461l6.4-6.4-6.4-6.4L4.658,3.22l6.4,6.4,6.4-6.4Z",
    transform: "translate(-3.22 -3.22)",
    fill: "#757575"
  }));
};
const StyledSVG = /*#__PURE__*/styled("svg")({
  name: "StyledSVG",
  class: "s1do8lb2"
});
export default IconNavclose;